import React, { useEffect, useState } from 'react';
import axios from "axios";
import base64 from "base-64"
import { Container } from "reactstrap"
import { set, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Navbar from './Navbar';
import Footer from './Footer';
import UpdateUser from '../services/updateProfile'
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assests/css/Myprofile.css'
import IdleMonitor from './userAutoLogout';
import ENV from '../env'; //session management

const MyProfile = () => {
    const history = useHistory();
    const [disButton, setDisButton] = useState(false)
    const [pswdIcon, setPswdIcon] = useState(false)
    const [pswdConIcon, setConPswdIcon] = useState(false)
    const [oldPswdTxt, setOldPswdTxt] = useState("password")
    const [pswdOldIcon, setOldPswdIcon] = useState(false)
    const [pswdTxt, setPswdTxt] = useState("password")
    const [pswdConTxt, setConPswdTxt] = useState("password")
    const [pswdNotMatch, setPswdNotMatch] = useState(false)
    const [userData, setUserData] = useState({})
    const [emailError, setEmailError] = useState(false)
    const [fnameError, setFnameError] = useState(false)
    const [lnameError, setLnameError] = useState(false)
    const [loading, setLoading] = useState(false)
    const [profileLoading, setProfileLoading] = useState(false)
    const [pswdLoading, setPswdLoading] = useState(false)
    const [lname ,setlname] = useState('')
    const [fname ,setfname] = useState('')

    useEffect(() => {
        // console.log("in useeffect", data)
        userProfileDetail()
    }, [(loading === true)]);

    const userProfileDetail = () => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let apiUrl = `${ENV.LOCUSB_API}/UserProfile/${userId}`
            axios.get(apiUrl, options)
                .then(response => {
                    if (response.data.success === "true") {
                         console.log("API response", response.data)
                        setUserData(response.data.data)
                        setProfileLoading(false)
                    } else {
                        if (response.data.errorMsg === "Invalid_SecureToken") {
                            history.push('/')
                            toast.error("Session expired, Please login again")
                            console.log("Invalid secure token")
                        }
                        else console.log("something went wrong in load activities API")
                    }
                })

        }).catch((err) => {
            console.log("err", err)
        })
    }

    const changePassword = (body) => {
        Promise.all([
            localStorage.getItem('userId'),
            localStorage.getItem('sToken')
        ]).then(async (res) => {
            let userId = JSON.parse(res[0]);
            let sToken = JSON.parse(res[1]);
            let header = base64.encode(`${userId}:${sToken}`);
            let security = `Basic ${header}`;

            const options = {
                headers: {
                    'Accept': 'application/json',
                    'Security': security,
                    'Content-Type': 'application/json',
                }
            };

            let apiUrl = `${ENV.LOCUSB_API}/userPasswordChange`
            axios.post(apiUrl, body, options)
                .then(response => {
                    if (response.data.success === "true") {
                        toast.success("Password Changed successfully!!!")
                    } else {
                        if (response.data.errorMsg === "Not a Valid Current Password") {
                            console.log("API response", response.data.errorMsg )

                            toast.error("Not a Valid Current Password")
                           setTimeout(()=>{
                            window.location.reload();
                           },3000) 

                        } else {
                            if (response.data.errorMsg === "Invalid_SecureToken") {
                                history.push('/')
                                toast.error("Session expired, Please login again")
                                // console.log("Invalid secure token")
                            }
                            else toast.warn("Something went wrong, try again!")
                        }
                    }
                    setDisButton(false)
                    reset2(register2);
                    setPswdLoading(false);
                })

        }).catch((err) => {
            console.log("err", err)
        })
    }

    const { register, handleSubmit/*, reset*/, formState: { errors } } = useForm();
    const { register: register2, reset: reset2, formState: { errors: errors2 }, handleSubmit: handleSubmit2 } = useForm({
        mode: "onBlur",
    });

    const updateUserDataState = (field, detail) => {
        setUserData({ ...userData, [field]: detail })
    }

    //update profile submit
    const onSubmit = async () => {
        setProfileLoading(true);
        if (emailError === true || fnameError === true || lnameError === true) {
            toast.warn("Field can't be empty!")
            setProfileLoading(false);
        } else {
            setLoading(true);
            // toast.success("Profile are succesfully updated")

            let data = {
                fName: userData.fName,
                lName: userData.lName,
                userId: userData.email
            }
            // console.log("userdata submit:", data)
            await UpdateUser(data).then((res) => {
                userProfileDetail();
                setLoading(false)
            });
        }
    }

    //change password submit
    const onPswdSubmit = data => {
        setPswdLoading(true);
        data.time = moment().format()
        setDisButton(true);
        if (data.passwd !== data.cpasswd) {
            setPswdNotMatch(true)
            setPswdLoading(false)

        }
        else {
            var reqBody = {
                emailId: userData.email,
                currentPwd: data.oldpasswd,
                newPwd: data.passwd
            }
            // API call
            changePassword(reqBody)
        }
    }
    console.log("userData.fName",userData.fName);
    console.log("userData.lName",userData.lName);

    return (
        <div className="mpmaindiv1" style={{ fontFamily: "Poppins", position: "relative" }}>
            <div style={{ width: "100%"}} className="manageHeight">
                <Navbar />
                <Container style={{ alignItems: "center", justifyContent: "center", paddingTop: "4rem" }}>
                <p className='mp-heading'>My Profile</p>

                    <div className="text-center bg-white mpmiddleDiv1 mx-auto">
                        <p className="mpheading">Personal Information</p><br /><br /><br />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                {/* Email input field */}
                                <div className="form-group input-group input-field mpMarginBottomErrorSpan">
                                    <span className="form-group input-group-text icon-setting left-icons1">Email Address:</span>
                                    <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                        <input className="mp-form-control" disabled="true" type="email" value={userData.email} onChange={e => { updateUserDataState("email", e.target.value); e.target.value.length === 0 ? setEmailError(true) : setEmailError(false) }} /*{...register("email", { required: true, maxLength: 50 })}*/ />
                                        <span className="errorSpan2">{emailError && "*Email is required"}</span></span>
                                </div>
                                {/* Full name input field */}
                                <div className="form-group input-group input-field mpMarginBottomErrorSpan">
                                    <span className="form-group input-group-text icon-setting left-icons1">First Name:</span>
                                    <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                        <input className="mp-form-control" type="text" style={{ textTransform: "capitalize" }} value={fname?fname:userData.fName} onChange={e => { setfname(e.target.value); updateUserDataState("fName", e.target.value); e.target.value.length === 0 ? setFnameError(true) : setFnameError(false) }} /*{...register("fName", { required: true, maxLength: 50 })}*/ />
                                        <span className="errorSpan2">{fnameError && "*First name is required"}</span></span>
                                </div>
                                {/* Last name input field */}
                                <div className="form-group input-group input-field mpMarginBottomErrorSpan">
                                    <span className="form-group input-group-text icon-setting left-icons1">Last Name:</span>
                                    <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                        <input className="mp-form-control" type="text" style={{ textTransform: "capitalize" }} value={lname?lname:userData.lName} onChange={e => {setlname(e.target.value); updateUserDataState("lName", e.target.value); e.target.value.length === 0 ? setLnameError(true) : setLnameError(false) }} /*{...register("lName", { required: true, maxLength: 50 })}*/ />
                                        <span className="errorSpan2">{lnameError && "*Last name is required"}</span></span>
                                </div>
                                <br />
                                <div className="btn-margin">
                                    <button type="submit" disabled={disButton} className="mpBtnDesg">
                                        {/* Save */}
                                        {(loading || profileLoading) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Save"}
                                    </button>
                                </div>
                            </div>
                            <ToastContainer />
                        </form>
                    </div>
                    {/* Change password */}
                    <div className="text-center bg-white mpmiddleDiv1 mx-auto">
                        <p className="mpheading">Change Password</p><br /><br /><br />
                        <form onSubmit={handleSubmit2(onPswdSubmit)}>
                            {/* Current Password input field */}
                            <div className="form-group input-group input-field mpMarginBottomErrorSpan justify-content-end">
                                <span className="form-group input-group-text icon-setting left-icons1">Current password:</span>
                                <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                    <><input className="mp-form-control mp-pswd-input" type={oldPswdTxt} placeholder="Enter your current password" {...register2("oldpasswd", { maxLength: 20, minLength: 8, required: true })} />
                                        <span className="form-group input-group-text icon-setting right-icons">
                                            {pswdOldIcon ?
                                                <BsFillEyeFill onClick={e => { setOldPswdIcon(false); setOldPswdTxt("password") }} /> :
                                                <BsFillEyeSlashFill onClick={e => { setOldPswdIcon(true); setOldPswdTxt("text") }} />
                                            }
                                        </span></>
                                </span>
                                <span className="errorSpanPwd">{errors2.oldpasswd?.type === 'required' && "*Current password is required"}</span>
                                <span className="errorSpanPwd">{errors2.oldpasswd?.type === 'maxLength' && "*Current password contains most 20 characters"}</span>
                                <span className="errorSpanPwd">{errors2.oldpasswd?.type === 'minLength' && "*Current password contains least 8 characters"}</span>
                            </div>

                            {/* New Password input field */}
                            <div className="form-group input-group input-field mpMarginBottomErrorSpan justify-content-end">
                                <span className="form-group input-group-text icon-setting left-icons1">New password:</span>
                                <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                    <><input className="mp-form-control mp-pswd-input" type={pswdTxt} placeholder="Enter your new password" {...register2("passwd", { maxLength: 20, minLength: 8, required: true })} />
                                        <span className="form-group input-group-text icon-setting right-icons">
                                            {pswdIcon ?
                                                <BsFillEyeFill onClick={e => { setPswdIcon(false); setPswdTxt("password") }} /> :
                                                <BsFillEyeSlashFill onClick={e => { setPswdIcon(true); setPswdTxt("text") }} />
                                            }
                                        </span></>
                                </span>
                                <span className="errorSpanPwd">{errors2.passwd?.type === 'required' && "*New password is required"}</span>
                                <span className="errorSpanPwd">{errors2.passwd?.type === 'maxLength' && "*Password should contain at most 20 characters"}</span>
                                <span className="errorSpanPwd">{errors2.passwd?.type === 'minLength' && "*Password should contain at least 8 characters"}</span>
                            </div>

                            {/* Confirm Password input field */}
                            <div className="form-group input-group input-field mpMarginBottomErrorSpan justify-content-end">
                                <span className="form-group input-group-text icon-setting left-icons1">Confirm password:</span>
                                <span style={{ display: "flex", flex: 1, justifyContent: "end", marginBottom:"1rem" }}>
                                    <><input className="mp-form-control mp-pswd-input" type={pswdConTxt} placeholder="Confirm your password" onFocus={() => { setPswdNotMatch(false); setDisButton(false); }} {...register2("cpasswd", { required: true })} />
                                        <span className="form-group input-group-text icon-setting right-icons">
                                            {pswdConIcon ?
                                                <BsFillEyeFill onClick={a => { setConPswdIcon(false); setConPswdTxt("password") }} /> :
                                                <BsFillEyeSlashFill onClick={a => { setConPswdIcon(true); setConPswdTxt("text") }} />
                                            }
                                        </span></>
                                </span>
                                <span className="errorSpanPwd">{errors2.cpasswd?.type === 'required' && "*Confirm password is required"}</span>
                                <span className="errorSpanPwd">{pswdNotMatch && "*Password not matched"}</span>
                            </div>
                            <div className="btn-margin">
                                <button type="submit" disabled={disButton} className="mpBtnDesg mt-4">
                                    {(disButton && !pswdNotMatch || pswdLoading) ? <i className="bx bx-loader bx-spin font-size-24 align-middle me-2" /> : "Save"}</button>
                            </div>
                        </form>
                    </div>
                </Container>
                <IdleMonitor/>
                <Footer/>
            </div>
        </div>
    );
}

export default MyProfile;
